import get from "lodash.get";
import { REHYDRATE } from "redux-persist";
import AbstractApiReducer from "services/cores/abstractApiReducer";
import NonMovingCarsActionTypes from "./types";
import INITIAL_STATE from "services/cores/abstractInitialState";

const INITIAL_NON_MOVING_CARS_STATE = {
  filters: {
    duration: 0,
    areaType: [],
  },
  list: {
    orders: {
      arrival_time: "",
      duration: "desc",
      "meta_data.area.type": "",
    },
  },
};

class NonMovingCarsReducer extends AbstractApiReducer {
  constructor() {
    super(NonMovingCarsActionTypes, INITIAL_NON_MOVING_CARS_STATE);
    this.mapActionToMethods[REHYDRATE] = this.rehydrate;
  }

  rehydrate = (state, action) => {
    return {
      ...INITIAL_STATE,
      ...INITIAL_NON_MOVING_CARS_STATE,
      list: {
        ...INITIAL_STATE.list,
        ...INITIAL_NON_MOVING_CARS_STATE.list,
        orders: get(
          action,
          "payload.NonMovingCars.list.orders",
          INITIAL_NON_MOVING_CARS_STATE.list.orders
        ),
      },
    };
  };
}

const instance = new NonMovingCarsReducer();
export default instance.reducer;
